import { useSelectedLocation } from "components";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { KioskDashboardQueryKeys } from "modules/KioskDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { Kiosk } from "models";

export type CreateUpdateKioskPayload = Pick<Kiosk, "name" | "confirmation_title" | "confirmation_image_url" | "is_custom_web_page_enabled"> & {
  stand_by_image_url?: string;
  custom_web_page_display_text?: string;
};

type CreateKioskResponse = {
  kiosk_id: number;
  private_key: string;
};

export const useCreateKioskMutation = () => {
  const { selectedLocation } = useSelectedLocation();

  return useTypedMutation<CreateUpdateKioskPayload, CreateKioskResponse>({
    mutationFn: async payload => (await ApiInstance.post("/dashboard/create", { ...payload, dealer_location_id: selectedLocation?.id }, ENV.kioskBaseURL)).data,
    onSuccess: (payload, { kiosk_id }) => {
      const kiosks = typedQueryClient.getQueryData(KioskDashboardQueryKeys.kiosks);
      if (!kiosks) return;

      const kioskIdx = kiosks.findIndex(kiosk => kiosk.id === kiosk_id);
      if (kioskIdx > -1) return;

      const now = toISOString(new Date());

      typedQueryClient.setQueryData(KioskDashboardQueryKeys.kiosks, [
        ...kiosks,
        {
          ...payload,
          id: kiosk_id,
          created_on: now,
          updated_on: now,
          active: false,
          front_end_version: 0,
          dealer_location_id: selectedLocation?.id ?? 0,
          stand_by_image_url: payload.stand_by_image_url ?? "",
          custom_web_page_display_text: payload.custom_web_page_display_text ?? ""
        }
      ]);
    }
  });
};
